export const setIframeSize = (
  verticalWidth,
  verticalHeight,
  isFullScreenWidget,
) => {
  const headerHeight = 66
  if (isFullScreenWidget) {
    return {
      width: '100%',
      height: `calc(100% - ${headerHeight}px)`,
    }
  }
  return {
    width: verticalWidth > 0 ? `${verticalWidth}px` : '360px',
    height: verticalHeight > 0 ? `${verticalHeight - headerHeight}px` : '470px',
  }
}

export const setIframeColor = color => ({
  backgroundColor: color,
})
